export const SECTION_BORDER_PIXEL = "0.5px";
